(function(){  
  $('.navbar-item.menu').on('click', function(e){
    $('.navbar-group.opened').removeClass('opened');
  	$('.footer-navbar-mobile-v2').toggleClass('hidden');
    return false;
  });
  
  
  $('body').click(function(e) {
    if ($(e.target).closest('.navbar-item.menu, .footer-navbar-mobile-v2').length) return;
  	$('.navbar-group.opened').removeClass('opened');
    $('.footer-navbar-mobile-v2').addClass('hidden');
  });
  
  $('.navbar-group').click(function(e){
    $('.navbar-group.opened').removeClass('opened');
    $(this).toggleClass('opened');
  });
  
  
  $('.footer.sticky-footer-nav-bottom-margin .column').click(function(e){
    $(this).toggleClass('opened');
  });
  
  // show canadian banner if on usa site and has canadian ip
  if(window.location.host === 'corkcicle.ca'){
    $.getJSON('https://ipapi.co/json/', function(data){
      
      console.log(data.country_name);

      if(data.country_name === 'United States' && !localStorage.getItem('corkcicle-usa-banner-hide')){
        $('.canada-banner').show();
      }
    });
  }

  $('.canada-banner button').click(function() {
  	$('.canada-banner').hide();
    
    localStorage.setItem('corkcicle-usa-banner-hide', 'true');
  });
})();